import { Status } from "@/models/courses.model";

import { GenericsUtils } from "@/utils/generics.util";

export class CardUtils {
  getStatus(status: string): string {
    if (status == Status.PUBLISHED) {
      status = GenericsUtils.translateI18n("course.tabs.published");
    } else if (status == Status.APPROVED) {
      status = GenericsUtils.translateI18n("course.tabs.approved");
    } else if (status == Status.REPROVED) {
      status = GenericsUtils.translateI18n("course.tabs.repproved");
    } else if (status == Status.WAITING) {
      status = GenericsUtils.translateI18n("course.tabs.waiting");
    } else if (status == Status.NOT_PUBLISHED) {
      status = GenericsUtils.translateI18n("course.tabs.notPublished");
    } else if (status == Status.NOT_LISTED) {
      status = GenericsUtils.translateI18n("course.tabs.notListed");
    }
    return status;
  }
  getStatusColor(status: string): string {
    if (status == Status.PUBLISHED) {
      status = "bg-h-success-100";
    } else if (status == Status.APPROVED) {
      status = "bg-h-primary-100";
    } else if (status == Status.REPROVED) {
      status = "bg-h-warning-100";
    } else if (status == Status.WAITING) {
      status = "bg-h-secondary-100";
    } else if (status == Status.NOT_PUBLISHED) {
      status = "bg-h-error-100";
    } else if (status == Status.NOT_LISTED) {
      status = "bg-h-neutral-100";
    }
    return status;
  }
}
